<!-- Card mit den Bestellpositionen -->
<div class="card">

  <div class='card-header text-center'>
    <div class='row'>
      <div class='col'>
        <h5 class='card-title'>Bestellpositionen: </h5>
      </div>
    </div>
  </div>

  <div class="card-body">

    <div *ngIf="!items" class='row'>
      <div class='col text-center'>
        <p class='text-danger'>
          Noch keine Bestellpositionen vorhanden
        </p>
      </div>
    </div>

    <div *ngIf="items" class='row'>
      <div class='col'>

        <table class='table'>
          <thead>
            <tr>
              <td>
                Art-Nr
              </td>
              <td>
                Bezeichnung
              </td>
              <td>
                Einzelpreis
              </td>
              <td>
                Anzahl
              </td>
              <td>
                Gesamtpreis
              </td>
              <td>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of items">
              <td>
                {{item.Product.IdDisplay}}
              </td>
              <td>
                {{item.Product.Name}}
                <span *ngIf="item.Variant">
                  (Variante: {{item.Variant}})
                </span>
              </td>
              <td>
                {{getPrice(item)}} &euro;
              </td>
              <td>
                {{item.Quantity}}
              </td>
              <td>
                {{getFullPrice(item)}} &euro;
              </td>
              <td>
                <div class='row'>
                  <div class='col'>
                    <a class='clickable ml-auto' (click)="itemService.quantityChange(item.IdProduct, 'up')">
                      <i class='fas fa-plus'></i>
                    </a>
                    <a class='clickable ml-1' (click)="itemService.quantityChange(item.IdProduct, 'down')">
                      <i class='fas fa-minus'></i>
                    </a>
                  </div>
                  <div class='col'>
                    <a class='clickable ml-1 float-right' (click)="itemService.removeItem(item.IdProduct)">
                      <i class='fas fa-trash'></i>
                    </a>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div class='row'>
          <div class='col'>
            Gesamt: &euro;
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class='card-footer'>
    <div class='col btn-group ml-auto'>
      <button type='button' class='btn btn-primary' (click)="openAddItem()" title="Neue Bestellposition">
        <i class='fas fa-plus'></i>
      </button>
    </div>
  </div>